export default __webpack_public_path__ + "static/media/physicsIcon.8dac19ea.svg";